module.exports = __webpack_public_path__ + "img/5d532.2e52fd1d.png";